import { secondaryColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  white-space: nowrap;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    gap: 1.6rem;
  }
`;

export const StyledWrapRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
`;

export const StyledBar = styled.div<{ $thin: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.6rem;
  gap: 1.6rem;
  background: ${secondaryColors.offBlack};
  overflow: hidden;
  position: relative;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: row;
    flex-wrap: wrap;
    flex-basis: 9.7rem;
    flex-shrink: 0;
    justify-content: center;
    gap: 3.2rem;
  }
`;

export const StyledText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-weight: 800;
  line-height: 3.3rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.main};

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  sup {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 2.4rem;
  }
`;

export const StyledHighlight = styled.span`
  color: ${({ theme }) => theme.colors.primary.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
`;

export const StyledSaber = styled.div<{ onRight?: boolean }>`
  position: absolute;
  transform: rotate(-20deg) scale(0.7);
  top: ${({ onRight }) => (onRight ? 'auto' : '-1.3rem')};
  bottom: ${({ onRight }) => (onRight ? '3rem' : 'auto')};
  left: ${({ onRight }) => (onRight ? 'auto' : '-25rem')};
  right: ${({ onRight }) => (onRight ? '-36rem' : 'auto')};

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    left: ${({ onRight }) => (onRight ? 'auto' : '-28rem')};
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    top: ${({ onRight }) => (onRight ? 'auto' : '0.7rem')};
    bottom: ${({ onRight }) => (onRight ? '3rem' : 'auto')};
    left: ${({ onRight }) => (onRight ? 'auto' : '-17rem')};
    right: ${({ onRight }) => (onRight ? '-27rem' : 'auto')};
  }
`;
